






























import { Vue, Component } from "vue-property-decorator";
import { TermCreate as ITermCreate } from "@/api/models/term-create";
import api from "@/getinfo-api";

@Component({ components: {} })
export default class DocumentTypeTaxonomyNew extends Vue {
  title!: string;
  description!: string;
  data() {
    return {
      title: undefined,
      description: undefined
    };
  }

  createDocumentType() {
    let params: ITermCreate = {
      title: this.title,
      description: this.description
    };
    api.DocumentTypeTaxonomyApi.create(params).then(() => {
      this.$store.dispatch("successToast", {
        message: this.$tc(this.$translate.Successful)
      });
      this.$router.push({ name: "documentTypeTaxonomyList" });
    });
  }
}
